<template>
	<div class="page lottery-page">
		<van-nav-bar :title="pageTitle" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="lottery-record">
			<div class="record-period">
				<van-image class="record-icon" src="/img/mine/head_logo.png">
					<template v-slot:loading>
						<van-loading type="spinner" />
					</template>
				</van-image>
				<div class="period-meta">
					<span class="running-tag">进行中</span>
					<span class="period-number">{{ lottery.next_expect || lottery.now_expect }}</span>
				</div>
				<div class="next-number">
					<span>剩余时间：</span>
					<van-count-down :time="time" @finish="check()" />
				</div>
			</div>
			<div class="last-result">
				<div><strong>{{ lottery.now_expect || '--' }}</strong><small>期号</small></div>
				<div class="result-icons"><span v-for="result in historyOptions(lottery)" :key="result"><img :src="resultImage(result)" :alt="resultLabel(result)" /></span></div>
				<van-icon :name="active ? 'arrow-up' : 'arrow-down'" @click="active = !active" />
			</div>
			<transition name="history-slide">
				<div v-show="active" class="history-dropdown">
					<div class="history-dropdown-head"><span>期号</span><span>数据</span></div>
					<div class="history-dropdown-body">
						<div class="history-dropdown-row" v-for="(v,key) in lottery_list" :key="key">
							<strong>{{ v.expect }}</strong>
							<div>
								<span v-for="result in historyOptions(v)" :key="result"><img :src="resultImage(result)" :alt="result" /></span>
							</div>
						</div>
					</div>
				</div>
			</transition>
		</div>

		<div class="lottery-body">
			<div class="options-bar">
				<div class="game-options">
					<div class="sumValueTwoSides">
						<div class="option-card" :class="{ active: choose[v.type] }"
							v-for="(v, key) in lottery_peilv_list" :key="key" @click="choosePlay(v.type, v.name)">
							<div class="option-inner">
								<span class="option-visual"><img :src="optionImage(v.type, v.name)" :alt="v.name" /></span>
								<p class="option-name">
									{{ optionLabel(v.type, v.name) }}
								</p>
								<!-- <p class="option-odd">{{ v.proportion }}</p> -->
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Bottom bar -->
			<div class="bottom-bar">
				<div class="bar-main">
					<div class="bar-left">
						<div class="bar-item">
							<van-icon name="cart-o" class="cart-icon" />
						</div>
					</div>
				<div class="bar-mid">
					<span class="bar-text">余额</span>
					<span class="bar-num">{{ this.userInfo.money }}</span>
					</div>
					<div class="bar-right" @click="jiesuan()">
						投票
					</div>
				</div>

				<div class="bar-slider" :class="{ active: shopping }">
					<div class="slider-item">
						<span class="slider-label">{{ $t("reservation.curr_choose") }}：</span>
						<div class="slider-value">{{ convertedShopchoose }}</div>
					</div>
					<div class="slider-item">
						<span class="slider-label">数量</span>
						<div class="quantity-control">
							<button type="button" @click="decreaseQuantity">−</button>
							<van-field v-model="money" type="digit" class="slider-input" />
							<button type="button" @click="increaseQuantity">＋</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Settlement popup -->
			<van-popup v-model="jiesuanpage" get-container="body">
				<div class="settlement-modal">
					<h2 class="settlement-title">确认投票</h2>
					<ul class="settlement-list">
						<li><span>认证类型</span><strong>{{ pageTitle }}</strong></li>
						<li><span>期号</span><strong>{{ lottery.next_expect || lottery.now_expect }}</strong></li>
						<li><span>当前选择</span><strong>{{ selectedLabels }}</strong></li>
						<li><span>数量</span><strong>{{ money }}</strong></li>
						<li class="total-row"><span>总票数</span><strong>{{ Number(money || 0) * formData.length }}</strong></li>
					</ul>
					<div class="settlement-actions">
						<van-button class="action-cancel" type="default"
							@click="jiesuanpage = false">取消</van-button>
						<van-button class="action-submit" type="default"
							@click="doSub">确认提交</van-button>
					</div>
				</div>
			</van-popup>

		</div>

		<!-- Game switch popup -->
		<van-popup v-model="showModel" position="right" :style="{ width: '70%', height:'100%' }">
			<div class="game-switch-list">
				<div class="switch-item" v-for="(i,index) in gameitemData" :key="index" @click="tabList(i.id,i.key)">
					<div class="switch-icon">
						<van-image width="48" height="48" :src="i.ico" />
					</div>
					<div class="switch-name">{{ i.name }}</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	var time;
	var count = 0;
	export default {
		data() {
			return {
				jiesuanpage: false,
				showModel: false,
				rose: '',
				lily: '',
				balloon: "",
				fireworks: "",
				choose: {
					big: false,
					small: false,
					one: false,
					two: false,
					"3": false,
					"4": false,
					"5": false,
					"6": false,
					"7": false,
					"8": false,
					"9": false,
					"10": false,
					"11": false,
					"12": false,
					"13": false,
					"14": false,
					"15": false,
					"16": false,
					"17": false,
					"18": false,
				},
				playgame: false,
				shopping: true,
				isLoading: false,
				play: {},
				lottery_peilv_list: {},
				lottery_list: {},
				active: false,
				userInfo: {},
				lottery: {},
				sum: 0,
				size: "",
				double: "",
				time: 0,
				shopchoose: this.$t("reservation.no_choose"),
				gameitem: "",
				formData: [],
				money: "100",
				ids: 11,
				keys: 5,
				gameitemData: [],
			};
		},
		methods: {
			historyOptions(item) {
				const values = Array.isArray(item.opencode) ? item.opencode : String(item.opencode || '').split(',');
				const sum = values.reduce((total, value) => total + Number(value || 0), 0);
				return [sum >= 11 ? 'rose' : 'yacht', sum % 2 === 0 ? 'heart' : 'rocket'];
			},
			resultImage(result) {
				return '/img/certification/' + result + '.png';
			},
			resultLabel(result) {
				return { rose: '玫瑰', yacht: '游艇', heart: '爱心', rocket: '火箭' }[result] || result;
			},
			optionLabel(type, name) {
				const key = String(type || name || '').toLowerCase();
				return { big: '玫瑰', small: '游艇', one: '爱心', two: '火箭' }[key] || name;
			},
			decreaseQuantity() {
				this.money = String(Math.max(100, (parseInt(this.money, 10) || 100) - 100));
			},
			increaseQuantity() {
				this.money = String((parseInt(this.money, 10) || 0) + 100);
			},
			optionImage(type, name) {
				const key = String(type || name || '').toLowerCase();
				if (key === 'big') return '/img/certification/rose.png';
				if (key === 'small') return '/img/certification/yacht.png';
				if (key === 'one') return '/img/certification/heart.png';
				return '/img/certification/rocket.png';
			},
			back() {
				return window.history.back();
			},
			isBigSum(sum) {
				return sum >= 11 && sum <= 18;
			},
			doSub() {
				if (this.money === "0") {
					this.$toast(this.$t("reservation.money_err"));
					return false;
				}
				if (this.formData.length === 0) {
					this.$toast(this.$t("reservation.choose_num"));
					return false;
				}
				if (this.money === "") {
					this.$toast(this.$t("reservation.price_place"));
					return false;
				}
				if (this.userInfo.money - this.money * this.formData.length < 0) {
					this.$toast(this.$t("reservation.balance_enough"));
					return false;
				}
				this.$http({
					method: "post",
					data: {
						item: this.gameitem,
						money: this.money,
						lid: this.lottery.id,
						mid: this.userInfo.id,
						expect: this.lottery.now_expect
					},
					url: "game_place_order",
				}).then((res) => {
					if (res.code === 200) {
						this.$toast(res.msg);
						this.allClear();
						this.getUserInfo();
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			allClear() {
				for (var i = 0; i < this.formData.length; i++) this.choose[this.formData[i]["type"]] = false;
				this.formData.length = 0;
				this.money = "100";
				this.shopchoose = this.$t("reservation.no_choose");
				this.gameitem = "";
				this.shopping = true;
				this.jiesuanpage = false;
			},
			jiesuan() {
				if (this.formData.length === 0) {
					this.$toast(this.$t("reservation.choose_num"));
					return false;
				}
				if (this.money === "") {
					this.$toast(this.$t("reservation.price_place"));
					return false;
				}
				this.jiesuanpage = !this.jiesuanpage;
			},
			clearChooes(type) {
				for (var i = 0; i < this.formData.length; i++) {
					if (type === this.formData[i]["type"]) {
						this.formData.splice(i, 1);
						this.choose[type] = false;
					}
				}
				if (this.formData.length >= 1) {
					this.shopchoose = this.formData.map(j => j["name"]).join(',');
					this.gameitem = this.formData.map(j => j["type"]).join(',');
				} else {
					this.shopchoose = this.$t("reservation.no_choose");
					this.gameitem = "";
					this.shopping = true;
				}
				if (this.formData.length === 0) this.jiesuanpage = false;
			},
			choosePlay(type, name) {
				if (this.choose[type]) {
					this.choose[type] = false;
					this.formData = this.formData.filter(f => f.type !== type);
				} else {
					this.formData.push({
						name,
						type
					});
					this.choose[type] = true;
				}
				if (this.formData.length === 1) this.shopping = true;
				if (this.formData.length >= 1) {
					this.shopchoose = this.formData.map(j => j["name"]).join(',');
					this.gameitem = this.formData.map(j => j["type"]).join(',');
				} else {
					this.shopchoose = this.$t("reservation.no_choose");
					this.gameitem = "";
					this.shopping = true;
				}
			},
			check() {
				if (!localStorage.getItem("token")) this.$router.push({
					path: "/Login"
				});
				else {
					time = window.setInterval(() => {
						setTimeout(() => {
							this.getUserInfo();
							this.getLotteryInfo();
							this.getLotteryList();
							count++;
							if (count > 5) {
								clearInterval(time);
								count = 0;
							}
						}, 0);
					}, 300);
				}
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast(this.$t("reservation.refresh"));
					this.getLotteryList();
					this.isLoading = false;
				}, 200);
			},
			getUserInfo() {
				this.$http({
					method: "get",
					url: "user_info"
				}).then((res) => {
					if (res.code === 200) this.userInfo = res.data;
					else if (res.code === 401) this.$toast(res.msg);
				});
			},
			getLotteryPeilv() {
				this.$http({
					method: "get",
					data: {
						id: this.ids
					},
					url: "lottery_get_peilv"
				}).then((res) => {
					if (res.code === 200) this.lottery_peilv_list = res.data;
					else if (res.code === 401) this.$toast(res.msg);
				});
			},
			getLotteryList() {
				this.$http({
					method: "get",
					data: {
						key: this.keys
					},
					url: "lottery_get_one_list"
				}).then((res) => {
					if (res.code === 200) {
						this.lottery_list = res.data;
						this.getLotteryPeilv();
					} else if (res.code === 401) this.$toast(res.msg);
				});
			},
			getGameItem() {
				this.$http({
					method: 'get',
					url: 'lottery_list'
				}).then(res => {
					this.gameitemData = res.data;
				});
			},
			tabList(id, key) {
				this.ids = id;
				this.keys = key;
				this.showModel = false;
				this.getUserInfo();
				this.getGameItem();
				this.getLotteryInfo();
				this.getLotteryList();
			},
			getCookie(name) {
				name = name + '=';
				const decodedCookie = decodeURIComponent(document.cookie);
				const cookies = decodedCookie.split(';');
				for (let i = 0; i < cookies.length; i++) {
					let cookie = cookies[i];
					while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
					if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length);
				}
				return '';
			},
			getLotteryInfo() {
				this.$http({
					method: "get",
					data: {
						key: this.keys
					},
					url: "lottery_get_info"
				}).then((res) => {
					if (res.code === 200) {
						const sel_id = this.getCookie('selid');
						if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
							this.$toast(this.$t("reservation.contact_admin"));
							this.$router.push({
								path: "/Home"
							});
							return false;
						}
						this.lottery = res.data;
						this.time = res.data.second * 1000;
						if (this.time / 1000 === 59) this.$toast(this.$t("reservation.prize_succ") + this.lottery
							.now_expect);
						this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
						if (sel_id == 1) {
							this.size = this.sum >= 11 && this.sum <= 18 ? '玫瑰' : '游艇';
							this.double = this.sum % 2 === 0 ? '爱心' : '火箭';
						} else {
							this.size = this.sum >= 11 && this.sum <= 18 ? '玫瑰' : '游艇';
							this.double = this.sum % 2 === 0 ? '爱心' : '火箭';
						}
					} else if (res.code === 401) this.$toast(res.msg);
				});
			},
		},
		created() {
			const authLotteries = {
				identity: { id: 11, key: 5 },
				video: { id: 12, key: 6 },
				privacy: { id: 13, key: 7 }
			};
			const authLottery = authLotteries[this.$route.query.auth] || authLotteries.identity;
			this.ids = authLottery.id;
			this.keys = authLottery.key;
			if (!localStorage.getItem("token")) this.$router.push({
				path: "/Login"
			});
			else {
				this.getUserInfo();
				this.getGameItem();
				this.getLotteryInfo();
				this.getLotteryList();
			}
			const lang = localStorage.getItem("lang");
			const r = lang == 'zh' ? '玫瑰' : 'Roses';
			const l = lang == 'zh' ? '游艇' : 'Yacht';
			const b = lang == 'zh' ? '爱心' : 'Heart';
			const f = lang == 'zh' ? '火箭' : 'Rocket';
			this.rose = r;
			this.lily = l;
			this.balloon = b;
			this.fireworks = f;
		},
		computed: {
			selectedLabels() {
				return this.formData.map(item => this.optionLabel(item.type, item.name)).join('、');
			},
			pageTitle() {
				const titles = {
					identity: '车费认证',
					video: '酒店认证',
					privacy: '保密认证'
				};
				return titles[this.$route.query.auth] || this.$t('reservation.hall');
			},
			convertedShopchoose() {
				const mapping = { big: '玫瑰', small: '游艇', one: '爱心', two: '火箭' };
				return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
			}
		},
		destroyed() {
			clearInterval(time);
		},
	};
</script>

<style lang="less" scoped>
	.lottery-page {
		display: flex;
		flex-direction: column;
		background: #f6f5f2;
		padding-bottom: 210px;
	}

	.nav-bar {
		background: linear-gradient(135deg, #7c6ff0, #db6ea9) !important;
	}

	/* Record section */
	.lottery-record {
		background: linear-gradient(135deg, #7c6ff0, #db6ea9);
		padding: 12px 20px;
	}

	.record-period {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.record-icon {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		overflow: hidden;
		flex-shrink: 0;
	}

	.period-number {
		flex: 1;
		font-size: 24px;
		font-weight: 700;
		color: #fff;
	}

	.van-count-down {
		color: #ffd700;
		font-size: 32px;
	}

	/* Options */
	.lottery-body {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.options-bar {
		flex: 1;
		display: flex;
		padding: 16px;
	}

	.game-options {
		flex: 1;
		overflow-y: auto;
	}

	.sumValueTwoSides {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
	}

	.option-card {
		width: calc(50% - 6px);
		background: rgba(255, 255, 255, .74);
		border-radius: var(--radius-md);
		box-shadow: var(--shadow-soft);
		backdrop-filter: blur(16px);
		-webkit-backdrop-filter: blur(16px);
		border: 1px solid rgba(255, 255, 255, .72);
		overflow: hidden;
		cursor: pointer;
		transition: all .2s ease;

		&.active {
			background: var(--gradient-primary);
			border-color: transparent;

			.option-name,
			.option-odd {
				color: #fff;
			}
		}

		&:active {
			transform: scale(.97);
		}
	}

	.option-inner {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 42px 16px;
		gap: 4px;
	}

	.option-name {
		font-size: 26px;
		font-weight: 600;
		color: var(--text);
	}

	.option-odd {
		font-size: 20px;
		color: var(--accent);
		font-weight: 700;
	}

	/* Bottom bar */
	.bottom-bar {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 110px;
		z-index: 10;
	}

	.bar-main {
		display: flex;
		align-items: center;
		height: 88px;
		padding: 0 16px;
		background: rgba(255, 255, 255, .92);
		backdrop-filter: blur(16px);
		-webkit-backdrop-filter: blur(16px);
		border-top: 1px solid rgba(17, 24, 39, .06);
		box-shadow: 0 -4px 20px rgba(0, 0, 0, .06);
	}

	.bar-left {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.bar-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 12px;
		cursor: pointer;
	}

	.cart-icon {
		font-size: 36px;
		color: var(--primary);
	}

	.bar-mid {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 4px;
	}

	.bar-text {
		font-size: 24px;
		color: var(--muted);
	}

	.bar-num {
		font-size: 28px;
		font-weight: 700;
		color: var(--accent);
	}

	.bar-right {
		padding: 0 28px;
		height: 56px;
		line-height: 56px;
		margin-left: 12px;
		border-radius: 999px;
		background: var(--gradient-primary);
		color: #fff;
		font-size: 26px;
		font-weight: 600;
		cursor: pointer;
	}

	.bar-slider {
		position: absolute;
		bottom: 100%;
		left: 0;
		right: 0;
		padding: 16px;
		background: rgba(255, 255, 255, .95);
		backdrop-filter: blur(16px);
		-webkit-backdrop-filter: blur(16px);
		box-shadow: 0 -4px 20px rgba(0, 0, 0, .06);
		transition: transform .3s cubic-bezier(.22, .61, .36, 1);
		transform: translateY(100%);

		&.active {
			transform: translateY(0);
		}
	}

	.slider-item {
		display: flex;
		align-items: center;
		padding: 8px 0;
	}

	.slider-label {
		font-size: 26px;
		color: var(--text);
		flex-shrink: 0;
	}

	.slider-value {
		flex: 1;
		margin: 0 12px;
		overflow-x: auto;
		white-space: nowrap;
		color: var(--accent);
		font-size: 26px;
		font-weight: 500;
	}

	.slider-input {
		flex: 1;
		font-size: 26px;
		border-bottom: 1px solid var(--border);
	}

	/* Settlement modal */
	.settlement-modal {
		width: 600px;
		max-height: 60vh;
		display: flex;
		flex-direction: column;
		padding: 20px;
		background: rgba(255, 255, 255, .95);
		border-radius: var(--radius-lg);
	}

	.settlement-list {
		flex: 1;
		overflow-y: auto;
		list-style: none;
	}

	.settlement-item {
		display: flex;
		align-items: center;
		padding: 12px 0;
		gap: 8px;
	}

	.item-main {
		flex: 1;
	}

	.item-name {
		color: var(--accent);
		font-size: 28px;
		font-weight: 600;
		margin-bottom: 4px;
	}

	.item-detail {
		font-size: 22px;
		color: var(--hint);
	}

	.settlement-actions {
		display: flex;
		gap: 16px;
		margin-top: 20px;
	}

	.action-cancel,
	.action-submit {
		flex: 1;
		height: 72px;
		border-radius: 999px;
		font-size: 28px;
		font-weight: 600;
		border: none !important;
	}

	.action-cancel {
		background: #f3f4f6;
		color: var(--muted);
	}

	.action-submit {
		background: var(--gradient-primary);
		color: #fff;
	}

	.settlement-modal { width:664px; max-width:calc(100vw - 48px); padding:42px 40px 36px; border:1px solid #846447; border-radius:28px; background:linear-gradient(155deg,#21141d,#321124); box-shadow:0 30px 80px rgba(0,0,0,.7),0 0 42px rgba(224,31,111,.12); color:#fff; }
	.settlement-title { display:block; margin:0 0 22px; padding:0; border:0; color:#fff; text-align:center; font-size:34px; font-weight:800; }
	.settlement-list { margin:0; padding:0; list-style:none; }
	.settlement-list li { display:flex; align-items:center; justify-content:space-between; min-height:72px; padding:0; border-bottom:1px solid rgba(255,255,255,.1); color:#d8cbd1; font-size:25px; }
	.settlement-list li strong { color:#fff; font-size:26px; font-weight:800; }
	.settlement-list li.total-row { border-bottom:0; }
	.settlement-list li.total-row strong { color:#ff8bad; }
	.settlement-actions { margin-top:28px; gap:16px; }
	.action-cancel,.action-submit { height:72px; border-radius:999px; font-size:26px; font-weight:700; }
	.action-cancel { border:1px solid #56464c !important; background:#221d1f; color:#d4c5cb; }
	.action-submit { background:linear-gradient(90deg,#ff5d9b,#e7196d); box-shadow:0 9px 24px rgba(230,27,109,.28); color:#fff; }

	/* History popup */
	.history-wrap {
		padding: 16px;
	}

	.history-header,
	.history-item {
		display: flex;
		align-items: center;
		padding: 12px 0;
	}

	.history-header {
		font-weight: 700;
		border-bottom: 1px solid var(--border);
		margin-bottom: 8px;
	}

	.col-left {
		width: 30%;
		font-size: 24px;
		color: var(--text);
	}

	.col-right {
		flex: 1;
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.ball {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: linear-gradient(135deg, var(--primary), var(--accent));
		color: #fff;
		font-size: 28px;
		font-weight: 700;
	}

	.result-sum {
		font-weight: 700;
		font-size: 20px;
		color: var(--text);
	}

	.result-tag {
		display: inline-block;
		padding: 2px 10px;
		border-radius: 999px;
		background: linear-gradient(135deg, var(--primary), var(--accent));
		color: #fff;
		font-size: 24px;
		font-weight: 700;
	}

	/* Game switch */
	.game-switch-list {
		padding: 20px;
	}

	.switch-item {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 16px;
		margin-bottom: 12px;
		background: rgba(255, 255, 255, .74);
		border-radius: var(--radius-md);
		box-shadow: var(--shadow-soft);
		cursor: pointer;
		transition: transform .2s ease;

		&:active {
			transform: scale(.97);
		}
	}

	.switch-icon {
		width: 48px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fff;
		border-radius: 12px;
		overflow: hidden;
	}

	.switch-name {
		font-size: 26px;
		font-weight: 600;
		color: var(--text);
	}

	/* Dark certification voting layout */
	.lottery-page { min-height:100%; background:linear-gradient(180deg,#4c1232 0,#190d15 330px,#09090a 660px); color:#fff; }
	.nav-bar { margin:14px 20px 0; border:1px solid #523c42; border-radius:18px; background:#151515 !important; overflow:hidden; }
	.nav-bar::after { display:none; }
	.nav-bar /deep/ .van-nav-bar__title { color:#f3d2b4; font-size:31px; font-weight:700; }
	.nav-bar /deep/ .van-icon { display:flex; align-items:center; justify-content:center; width:50px; height:50px; border:1px solid #705342; border-radius:50%; color:#f3d2b4 !important; }
	.lottery-record { position:relative; margin:18px 20px 0; padding:20px; border:1px solid rgba(229,65,135,.3); border-radius:24px; background:linear-gradient(145deg,rgba(111,22,68,.9),rgba(31,13,25,.95)); box-shadow:0 16px 34px rgba(0,0,0,.25); }
	.record-period { gap:14px; }
	.record-icon { width:88px; height:88px; border:2px solid #e5a657; border-radius:18px; }
	.period-meta { display:flex; min-width:0; flex:1; flex-direction:column; gap:8px; }
	.running-tag { align-self:flex-start; padding:4px 12px; border-radius:999px; background:#351a24; color:#ffc7d9; font-size:18px; }
	.period-number { color:#fff; font-size:30px; letter-spacing:2px; }
	.next-number { display:flex; align-items:center; gap:10px; padding:16px 18px; border:1px solid #db667d; border-radius:18px; color:#f6d5d7; font-size:21px; }
	.next-number .van-count-down { color:#ffd978; font-size:29px; font-weight:800; }
	.last-result { display:flex; align-items:center; margin-top:18px; padding-top:18px; border-top:1px solid rgba(255,255,255,.1); }
	.last-result>div:first-child { display:flex; flex-direction:column; gap:5px; }
	.last-result strong { font-size:27px; }.last-result small { color:#bfaeb5; font-size:19px; }
	.result-icons { display:flex; flex:1; gap:10px; margin-left:25px; }.result-icons span { display:flex; align-items:center; justify-content:center; width:58px; height:58px; padding:8px; border-radius:50%; background:#09090a; box-shadow:0 0 0 2px #502036; }.result-icons img { width:100%; height:100%; object-fit:contain; }
	.last-result>.van-icon { display:flex; align-items:center; justify-content:center; width:52px; height:52px; border:1px solid #6e3e4d; border-radius:16px; color:#f7ccdb; font-size:24px; }
	.history-dropdown { position:absolute; left:20px; right:20px; z-index:80; margin-top:10px; overflow:hidden; border:1px solid #775735; border-radius:22px; background:rgba(24,17,20,.98); box-shadow:0 22px 48px rgba(0,0,0,.55); }
	.history-dropdown-head { display:grid; grid-template-columns:1fr 1fr; height:62px; align-items:center; padding:0 22px; border-bottom:1px solid #4b3826; color:#f1cf9d; font-size:22px; font-weight:700; }
	.history-dropdown-head span:last-child { text-align:right; }
	.history-dropdown-body { max-height:510px; overflow-y:auto; padding:0 18px; scrollbar-color:#8a6736 transparent; scrollbar-width:thin; }
	.history-dropdown-row { display:grid; grid-template-columns:1fr 1fr; min-height:86px; align-items:center; padding:0 16px; border-bottom:1px solid rgba(255,255,255,.07); }
	.history-dropdown-row:last-child { border-bottom:0; }
	.history-dropdown-row strong { color:#d7cbd0; text-align:center; font-size:23px; letter-spacing:1px; }
	.history-dropdown-row>div { display:flex; justify-content:flex-end; gap:12px; }
	.history-dropdown-row span { display:flex; align-items:center; justify-content:center; width:58px; height:58px; padding:8px; border:1px solid #4d3440; border-radius:50%; background:#0b0b0c; }
	.history-dropdown-row img { width:100%; height:100%; object-fit:contain; }
	.history-slide-enter-active,.history-slide-leave-active { transition:opacity .2s,transform .2s; transform-origin:top; }
	.history-slide-enter,.history-slide-leave-to { opacity:0; transform:translateY(-10px) scaleY(.96); }
	.lottery-body { padding-top:20px; }
	.options-bar { padding:0 20px 285px; }
	.sumValueTwoSides { gap:14px; }
	.option-card { width:calc(50% - 7px); border:1px solid #67462f; border-radius:24px; background:linear-gradient(145deg,#1d181a,#0d0d0e); box-shadow:0 12px 26px rgba(0,0,0,.3); }
	.option-card.active { border-color:#ff78ae; background:radial-gradient(circle at 75% 15%,rgba(255,255,255,.25),transparent 22%),linear-gradient(145deg,#ff77b2,#e61b71); box-shadow:0 0 28px rgba(240,45,126,.3); }
	.option-inner { min-height:190px; padding:24px 12px; gap:12px; }
	.option-visual { display:flex; align-items:center; justify-content:center; width:112px; height:112px; padding:10px; border:2px solid #553641; border-radius:22px; background:#080809; box-shadow:0 10px 20px rgba(0,0,0,.35); }
	.option-visual img { width:100%; height:100%; object-fit:contain; }
	.option-card.active .option-visual { border-color:#fff; background:rgba(8,8,9,.92); }
	.option-name { color:#f6e7ec; font-size:28px; font-weight:800; }
	.bottom-bar { bottom:calc(112px + env(safe-area-inset-bottom)); z-index:9998; padding:0 20px 14px; background:linear-gradient(180deg,transparent,#09090a 24%); }
	.bar-main { height:100px; padding:0; border-top:1px solid #33262b; background:#0c0c0d; box-shadow:none; }
	.bar-left { display:none; }
	.bar-mid { align-items:flex-start; justify-content:center; flex-direction:column; padding-left:18px; }
	.bar-text { color:#d4c3ca; font-size:20px; }.bar-num { color:#ff79ad; font-size:31px; }
	.bar-right { min-width:190px; height:68px; margin-right:4px; line-height:68px; text-align:center; border-radius:999px; background:linear-gradient(90deg,#ff5c9b,#e7186c); box-shadow:0 8px 24px rgba(228,26,107,.32); font-size:29px; }
	.bar-slider { left:20px; right:20px; padding:18px; border:1px solid #4b3929; border-radius:22px 22px 0 0; background:#111112; color:#fff; }
	.slider-label { color:#d8cad0; }.slider-value { color:#ff7cae; }.slider-input { border-color:#514044; background:#171315; }
	.slider-input /deep/ input { color:#fff; }
	.quantity-control { display:flex; flex:1; align-items:center; justify-content:flex-end; gap:10px; }
	.quantity-control button { flex:0 0 58px; height:58px; padding:0; border:1px solid #66452e; border-radius:14px; background:#1d1719; color:#ffc07d; font-size:30px; }
	.quantity-control .slider-input { flex:0 0 190px; width:190px; height:58px; padding:7px 10px; border:1px solid #45343a; border-radius:14px; text-align:center; }
	.quantity-control .slider-input /deep/ input { text-align:center; font-size:29px; font-weight:800; }
</style>
